import axios from "axios";
import { airExchangeApi as defaultAirExchangeApi } from "@b2bportal/air-exchange-api";

export const flightsExchangeApi = defaultAirExchangeApi(axios);
